var map = {
	"./ada.png": "9a84",
	"./comingSoon.svg": "2160",
	"./complete.png": "86e8",
	"./critical-thinking.gif": "3282",
	"./disableADA.png": "6d9e",
	"./eforms.png": "3d49",
	"./en.png": "70ff",
	"./es.png": "b8cf",
	"./esflag.png": "7fee",
	"./law-book.png": "8f36",
	"./logo.png": "cf05",
	"./logo_old.png": "df01",
	"./nv.png": "521a",
	"./pdf.png": "9f06",
	"./qrcode.svg": "2a97",
	"./reset.png": "ffc4",
	"./smalllogo.png": "3342",
	"./smalllogo1.png": "fb3a",
	"./stopTalking.png": "0e69",
	"./talkButton.png": "4ce5",
	"./talkButtonActive.webp": "6770",
	"./usflag.png": "50f6",
	"./vi.png": "5207",
	"./video.png": "01f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";